import { FaHandsHelping } from "react-icons/fa";

const AttentionIcon = (props) => {
  return <FaHandsHelping className={props.className} />;
};

export default AttentionIcon;
